// Get RTC token from the authenticated backend endpoint.
// There is intentionally no unauthenticated fallback: a valid session is required.
export const getRtcToken = async (
  channelName: string,
  uid: number
): Promise<string> => {
  const accessToken = localStorage.getItem("access_token");

  if (!accessToken) {
    throw new Error("You must be signed in to join a live class.");
  }

  // Clean channel name (remove any special characters that might cause issues)
  const cleanChannelName = channelName.replace(/[^a-zA-Z0-9_-]/g, "");

  const url = `${process.env.REACT_APP_API_URL}/agora/rtc-token?channelName=${cleanChannelName}&uid=${uid}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  }).catch((error) => {
    if (error.name === "AbortError") {
      throw new Error("Request was cancelled");
    }
    throw error;
  });

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error("Your session has expired. Please sign in again.");
    }
    const errorText = await response.text();
    throw new Error(`Failed to get RTC token: ${response.status} ${errorText}`);
  }

  const data = await response.json();
  return data.token;
};

// Get RTM token
export const getRtmpToken = async (
  channelName: string,
  uid: string
): Promise<string> => {
  const accessToken = localStorage.getItem("access_token");

  if (!accessToken) {
    throw new Error("You must be signed in to join a live class.");
  }

  const url = `${process.env.REACT_APP_API_URL}/agora/rtm-token?uid=${uid}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  }).catch((error) => {
    if (error.name === "AbortError") {
      throw new Error("Request was cancelled");
    }
    throw error;
  });

  if (!response.ok) {
    throw new Error("Failed to get RTMP token");
  }

  const data = await response.json();
  return data.token;
};
